'use client'

import { REGEXP_ONLY_DIGITS } from "input-otp"
import { InputOTP as InputOTPBase, InputOTPGroup as InputOTPGroupBase, InputOTPSlot as InputOTPSlotBase } from "@/components/ui/input-otp"
import { navigateUrl } from '@/utils/client-request'
import { usePathname } from 'next/navigation'
import { useForgotPasswordFlow } from '@/lib/commerce/hooks'
import Link from 'next/link'
import { TextField, UnderlineTabs } from '../elements/Field'
import { authFocusRing, authLink, authPrimaryButton, authTitle } from './authStyles'

const InputOTP = InputOTPBase as any
const InputOTPGroup = InputOTPGroupBase as any
const InputOTPSlot = InputOTPSlotBase as any

const slotClass = 'size-11 sm:size-12 text-base border-border rounded-none! ring-foreground ring-offset-0'

export default function Forgot({ vendor }: { vendor: any }) {
  const pathname = usePathname()
  const f = useForgotPasswordFlow(vendor)
  const handleKeyDown = (event: any) => { if (event.key === 'Enter') f.sendOTP() }

  const sendButton = (
    <button type="button" onClick={f.sendOTP} disabled={f.sendOTPLoading} className={`mt-2 ${authPrimaryButton}`}>{f.sendOTPLoading ? 'Илгээж байна…' : 'Код илгээх'}</button>
  )

  return (
    <div>
      <h1 className={authTitle}>Нууц үг сэргээх</h1>

      {(f.step == 3 && f.sentOTP && f.verificationId) ? (
        <>
          <p className="mt-3 text-sm text-muted-foreground">Шинэ нууц үгээ оруулна уу</p>
          <form onSubmit={f.handleResetPassword} className="mt-10 flex flex-col gap-5">
            <TextField label="Шинэ нууц үг" type="password" onChange={e => f.setPassword(e.target.value)} placeholder="Таны шинэ нууц үг" description="8-аас дээш тэмдэгтэй байх ёстой" autoComplete="new-password" />
            <TextField label="Шинэ нууц үг давтах" type="password" onChange={e => f.setPasswordRep(e.target.value)} placeholder="Шинэ нууц үг давтах" autoComplete="new-password" />
            <button type="submit" disabled={f.loading} className={`mt-2 ${authPrimaryButton}`}>{f.loading ? 'Шинэчилж байна…' : 'Нууц үг солих'}</button>
          </form>
        </>
      ) : (f.step == 2 && f.sentOTP) ? (
        <>
          <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
            <span className="text-foreground">{f.identifier}</span> руу илгээгдсэн 6 оронтой кодыг оруулна уу.
          </p>
          <div className="mt-10">
            <InputOTP value={f.otp} onChange={f.setOTP} autoFocus={true} maxLength={6} pattern={REGEXP_ONLY_DIGITS} autoComplete="one-time-code">
              <InputOTPGroup>
                {[0, 1, 2, 3, 4, 5].map(index => <InputOTPSlot key={index} index={index} showChar={true} className={slotClass} />)}
              </InputOTPGroup>
            </InputOTP>
          </div>
          <button type="button" onClick={f.handleOTP} disabled={f.isOTPLoading} className={`mt-8 ${authPrimaryButton}`}>{f.isOTPLoading ? 'Баталгаажуулж байна…' : 'Баталгаажуулах'}</button>
          <div className="mt-6 flex items-center justify-between text-[13px]">
            <button type="button" onClick={f.reset} className={`text-muted-foreground transition-colors duration-150 hover:text-foreground ${authFocusRing}`}>Буцах</button>
            <button type="button" onClick={f.resendOTP} disabled={f.isCooldownActive || f.resendLoading} className={`tabular-nums disabled:text-muted-foreground disabled:cursor-not-allowed ${f.isCooldownActive || f.resendLoading ? authFocusRing : authLink}`}>
              {f.resendLoading ? 'Илгээж байна…' : f.isCooldownActive ? `Дахин илгээх (${f.cooldownSeconds}с)` : 'Дахин илгээх'}
            </button>
          </div>
        </>
      ) : (
        <>
          <p className="mt-3 text-sm text-muted-foreground">Бүртгэлтэй утас эсвэл имэйл рүү баталгаажуулах код илгээнэ</p>
          <div className="mt-10">
            <UnderlineTabs label="Сэргээх арга" options={[{ value: 'phone', label: 'Утасны дугаар' }, { value: 'email', label: 'Имэйл хаяг' }]} value={f.tab as 'phone' | 'email'} onChange={value => f.setTab(value)} />
            <div className="mt-6 flex flex-col gap-5">
              {f.tab === 'email' ? (
                <TextField label="Имэйл хаяг" type="email" placeholder="example@shop.mn" value={f.email} onChange={e => f.setEmail(e.target.value)} onKeyDown={handleKeyDown} autoComplete="email" />
              ) : (
                <TextField label="Утасны дугаар" type="text" inputMode="tel" placeholder="00000000" value={f.phone} onChange={e => f.setPhone(e.target.value)} onKeyDown={handleKeyDown} autoComplete="tel" />
              )}
              {sendButton}
            </div>
          </div>
          <p className="mt-8 pt-8 border-t border-border text-sm text-muted-foreground">
            Нууц үгээ санасан уу?{' '}
            <Link href={navigateUrl('/login', pathname)} className={authLink}>Нэвтрэх</Link>
          </p>
        </>
      )}
    </div>
  )
}
